import { useCallback } from 'react'
import ApiService from 'services/ApiService'
import { getMessage } from 'utility/MapperResponse'
import { showAlert } from 'utility/SweetAlert'

const InteractorTransactionFundPaymentView = () => {
  const transactionFundPaymentView = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/transaction/fund-payment/view', payload, (response) => {
      if (response.code === 7200 && response.data) {
        callback(response.data)
      } else {
        showAlert({
          icon: 'error',
          message: getMessage(response?.msg),
          timer: 2000,
          redirect: '/finance/payment/manage',
        })
      }
      loading(false)
    })
  }, [])
  return { transactionFundPaymentView }
}

export default InteractorTransactionFundPaymentView
